module.exports = __webpack_public_path__ + "img/icon-mastercard.c049e1b2.svg";